import angular from 'angular';

export default angular.module('shared', ['cloudService', 'helperModule']);



// WEBPACK FOOTER //
// ./modules/shared/shared.module.js